export enum StrainTestType {
    Initial = 0,
    Periodical = 1,
    Special = 2
}
